import React, { Component, Fragment } from 'react'
import { Typography, Button, FormControlLabel, Radio, } from '@material-ui/core';

class Step3 extends Component {
    render() {
        const { handleBack,BackFromWidget, onCreateWidget, widget, onShowWidget, focused, deliveryMethod, handleDeliveryMethodChange } = this.props;

        return (
            <div className="step3-wrapper" >
                <div className="step3-main-view">
                    <Typography variant='h5'>You're Almost Done</Typography>
                    {widget === '' ?
                        <Fragment>
                            <Typography style={{
                                textAlign: 'left',
                                marginTop: 10,
                            }}>
                                How visitors on your website interact with you using the Messaging Bridge Widget:</Typography>
                            <div className="step3-radio-wrapper">
                                <FormControlLabel
                                    style={{ margin: 0 }}
                                    control={
                                        <Radio
                                            value="1"
                                            color='primary'
                                            onChange={handleDeliveryMethodChange}
                                            checked={deliveryMethod === "1"}
                                        />
                                    }
                                    label="Message from website (Anonymous Email)"
                                />
                                <FormControlLabel
                                    style={{ margin: 0 }}
                                    control={
                                        <Radio
                                            value="3"
                                            color='primary'
                                            onChange={handleDeliveryMethodChange}
                                            checked={deliveryMethod === "3"}
                                        />
                                    }
                                    label="Message from website (Real Email)"
                                />
                                <FormControlLabel
                                    style={{ margin: 0 }}
                                    control={
                                        <Radio
                                            value="2"
                                            color='primary'
                                            onChange={handleDeliveryMethodChange}
                                            checked={deliveryMethod === "2"}
                                        />
                                    }
                                    label="Default email client (Anonymous Email)"
                                />

                            </div>


                            <div >
                                <input  onFocus={focused} ref={ref => this.usersUrlInput = ref} className='step3-input' style={{ width: '100%' }} placeholder='Enter your website URL' />
                            </div>
                        </Fragment>
                        : null
                    }
                </div>
                <div className='step3-buttons-wrapper'>
          
                    {widget === '' ?
                        <Fragment>
                            <Button
                                variant="outlined"
                                color='primary'
                                style={{ width: 156 }}
                                onClick={handleBack}
                            >
                                back
                             </Button>
                            <Button
                                variant="contained"
                                color='primary'
                                onClick={() => onCreateWidget(this.usersUrlInput.value)}
                                style={{ width: 156 }}
                            >
                                Create
                    </Button>
                        </Fragment> 
                        :
                        <Fragment>
                             <Button
                        variant="outlined"
                        color='primary'
                        style={{ width: 156 }}
                        onClick={BackFromWidget}
                    >
                        Cancel
                    </Button> 
                         <Button
                            variant="contained"
                            color='primary'
                            onClick={onShowWidget}
                            style={{ width: 156 }}
                        >
                            Show Widget
                    </Button>
                    </Fragment>
                    }
                </div>
            </div>
        )
    }
}

export default Step3;


// WEBPACK FOOTER //
// ./src/containers/widget/components/Steps/Step3.js